const TECHDOCS_SHADOW_STYLES_ID = 'techdocs-bui-tegel-mapping-styles';

const isRelevantStylesheet = (href: string | null, cssText: string) => {
  const source = `${href ?? ''}\n${cssText}`;
  return (
    source.includes('@backstage/ui') ||
    source.includes('@scania/tegel-lite') ||
    source.includes('bui-tegel-mapping') ||
    source.includes('--bui-') ||
    source.includes('bui-Button') ||
    source.includes('--traton-') ||
    source.includes('tl-mode-') ||
    source.includes('tl-icon')
  );
};

const serializeStylesheet = (stylesheet: CSSStyleSheet) => {
  try {
    return Array.from(stylesheet.cssRules)
      .map(rule => rule.cssText)
      .join('\n');
  } catch {
    return '';
  }
};

export const ensureTechDocsShadowStyles = (shadowRoot: ShadowRoot) => {
  const cssText = Array.from(document.styleSheets)
    .map(stylesheet => {
      const href = stylesheet.href;
      const serialized = serializeStylesheet(stylesheet as CSSStyleSheet);
      return isRelevantStylesheet(href, serialized) ? serialized : '';
    })
    .filter(Boolean)
    .join('\n');

  if (!cssText) return;

  const style =
    shadowRoot.getElementById(TECHDOCS_SHADOW_STYLES_ID) ??
    document.createElement('style');
  style.id = TECHDOCS_SHADOW_STYLES_ID;
  style.textContent = cssText;
  if (!style.isConnected) {
    shadowRoot.prepend(style);
  }
};

export const getCurrentThemeMode = () => {
  const modeElement = document.querySelector<HTMLElement>(
    '[data-theme-mode="dark"], [data-theme-mode="light"]',
  );
  return modeElement?.dataset.themeMode === 'dark' ? 'dark' : 'light';
};
